export default __webpack_public_path__ + "static/media/4454.ccefd4ac.png";